<template>
  <div>
    <el-dialog v-el-drag-dialog custom-class="" :close-on-click-modal="false" :visible.sync="innerVisible" :title="$t('CargoMsg.Cargo_ExpenseSelection')" :show-close="false" @close="cancel">

      <cargo-ag-grid
        :show-side-bar="false"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        :style="{width:'100%',height:'300px'}"
      />
      <div slot="footer">
        <div style="position:absolute;">
          <el-button type="primary" no="1" @click="removeEvent">{{ $t('SeaExport.Remove') }}</el-button>
        </div>
        <div>
          <el-button type="primary" no="2" @click="enterEvent">{{ $t('Billing.billingView_Determine') }}</el-button>
          <el-button no="3" @click="cancel">{{ $t('Billing.billingView_Close') }}</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getGridSelected } from '@/utils/agGrid'

export default {
  name: 'JobChargeAdjustmentDialog',
  props: {
    visible: { type: Boolean, required: true }, // 是否隐藏
    partCharges: { type: Array, required: true } // 弹框打开时默认传递条件
  },
  data() {
    return {
      showChargeAdjustmentDialog: false,
      chargeAdjustmentConditions: [],
      innerVisible: this.visible,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        getRowStyle: function(params) {
          const data = params.data
          if (data) {
            return (data['chargeConfirmState'] > 0 || data['chargeVerifiedAmount'] !== 0 || data['chargeDifferentState'] === 1 || data['chargeDifferentState'] === 2) ? { background: '#EFEFEF' } : { background: 'white' }
          }
        }
      },
      gridParams: {},
      gridApi: {},
      columnDefs: [],
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      rowData: this.partCharges ? this.partCharges : [],
      removeItems: []
    }
  },
  computed: {},
  created() {
    this.columnDefs = [
      {
        headerName: '', width: 60, checkboxSelection: true,
        sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
        headerCheckboxSelection: true
      },
      { headerName: this.$t('Billing.billingCharge_chargeItem'), field: 'chargeChargeItemId', width: 110,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
        } },
      { headerName: this.$t('Billing.billingCharge_paymentType'), field: 'chargeReceivable', width: 110,
        cellRenderer: (params) => {
          return ColumnUtils.chargeReceivableLabelFun(params.value)
        } },
      { headerName: this.$t('Billing.billingCharge_currency'), field: 'chargeCurrency', width: 110 },
      { headerName: this.$t('Billing.billingForm_unit'), field: 'chargeMeasure', width: 110,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeUnit, 'code', params.value, 'chineseName')
        } },
      { headerName: this.$t('Billing.billingCharge_amount'), field: 'chargeQuantity', width: 110,
        cellRenderer: (params) => {
          return ColumnUtils.number3ColumnLabelFunc(params.value)
        } },
      { headerName: this.$t('Billing.billingJob_unitPrice'), field: 'chargeUnitRate', width: 110,
        cellRenderer: (params) => {
          return ColumnUtils.number3ColumnLabelFunc(params.value)
        } },
      { headerName: this.$t('Billing.billingJob_taxIncludedPrice'), field: 'chargeAmount', width: 110,
        cellRenderer: (params) => {
          return ColumnUtils.number2ColumnLabelFunc(params.value)
        } },
      { headerName: this.$t('Billing.billingJob_taxExcludedPrice'), field: 'chargeExcludingTaxAmount', width: 110,
        cellRenderer: (params) => {
          return ColumnUtils.number2ColumnLabelFunc(params.value)
        } },
      { headerName: this.$t('Billing.billingJob_taxRate'), field: 'chargeTaxRate', width: 110,
        cellRenderer: (params) => {
          return ColumnUtils.number2ColumnLabelFunc(params.value)
        } },
      { headerName: this.$t('Billing.billingCharge_taxAmount'), field: 'chargeTaxAmount', width: 110,
        cellRenderer: (params) => {
          return ColumnUtils.number2ColumnLabelFunc(params.value)
        } },
      { headerName: this.$t('Billing.billingCharge_remarks'), field: 'chargeRemarks', width: 110 }
    ]
  },
  beforeMount() {
  },
  methods: {
    cancel() {
      this.$emit('update:visible', false)
    },
    enterEvent() {
      this.$emit('removePartBillChargeCallBackEvent', this.removeItems)
    },
    removeEvent() {
      const rowData = this.rowData
      const chooseRows = getGridSelected(this.gridOptions)
      if (!chooseRows || chooseRows.length === 0) {
        this.$message.error(this.$t('CargoMsg.Cargo_ExpenseNotSelected'))
        return
      }
      for (let i = 0; i < chooseRows.length; i++) {
        const charge = chooseRows[i]
        const index = rowData.indexOf(charge)
        if (index >= 0) {
          this.removeItems.push(charge)
          rowData.splice(index, 1)
        }
      }
    }
  }
}
</script>
